import { FC } from "react";
import Head from "next/head";

// ====================================================================
type SEOProps = {
    title: string;
    sitename?: string;
    description?: string;
};
// ====================================================================

const SEO: FC<SEOProps> = ({
                               title,
                               description,
                               // sitename = process.env.NEXT_PUBLIC_SITENAME,
                           }) => {
    return (
        <Head>
            <title>{`${title}`}</title>
            {/*- ${sitename}*/}
            <meta name="description" content={description} />
        </Head>
    );
};

export default SEO;
